import React from 'react'
import "./AddvertiseBanner.css"

function AddvertiseBanner() {
    return (
        <>
            <section className="AddvertiseBanner">

                <div className="container">
                    <div className="banner_card" >
                        <div className="img_holder">
                            <img src="/assets/Image/Home/AddvertiseBanner/banner_img.jpg" className="banner_img" />
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default AddvertiseBanner